import React from 'react'
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";

const Tr = (props) => {
    const { t } = useTranslation();

    const stock = props.stock;
    const statusList = [
        t('tr.preparation'),
        t('tr.sale'),
        t('tr.soldout'),
        t('tr.ended'),
        '',
        t('tr.release'),
        t('tr.stopping'),
    ]

    const { shop } = useParams();

    return (
    <>
        <tr>
            <td><img src={stock.url} alt=""/></td>
            <td>{stock.name}</td>
            <td>{stock.stock} / {stock.number}</td>
            <td>{stock.price}</td>
            <td>{stock.start} ~ {stock.end}</td>
            <td><div className={`stock-status-${stock.status}`}>{statusList[stock.status-1]}</div></td>
            <td>
                <Link to={`/${shop}/oripa/${stock.id}`}>
                    <button>{t('tr.detail')}</button>
                </Link>
            </td>
        </tr>
    </>
    )
}

export default Tr